var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneSpecialty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "131.666px",
    height: "117.25px",
    viewBox: "47.733 0 131.666 117.25",
    enableBackground: "new 47.733 0 131.666 117.25",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2a8ae5",
    d: "M47.733,96.725c0,0,32.868,20.2,66.469,20.2c33.6,0,65.197-18.8,65.197-18.8s-0.667-18.833-15.999-57 c-16.5-28-22.698-33.2-27.103-37.8C134.2,1.225,131.958,0,129.858,0c-2.4,0-4.656,1.425-6.559,3.125 c-3,2.5-4.357,2.203-9.148,2.337c-3.96-0.039-6.251,0.163-9.251-2.337c-2-1.7-4.6-3.125-7-3.125c-2.1,0-4,1.225-6,3.325 c-4.4,4.5-10.6,9.8-27.1,37.8C50.184,75.068,47.733,96.725,47.733,96.725z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "129,93.225 117.601,93.225 117.601,81.925 110.702,81.925 110.702,93.225 99.301,93.225  99.301,100.225 110.702,100.225 110.702,111.523 117.601,111.523 117.601,100.225 129,100.225  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    d: "M66.401,30.925c-2.7,6.1-4.5,12.3-4.5,17.6 c0,20,44.301,24,52,24h0.2c7.7,0,52-4,52-24c0-5.399-1.8-11.5-4.5-17.6"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneSpecialty);
export default __webpack_public_path__ + "static/media/one_specialty.d0a535e2ffd16f365d0cb2f1885bfad5.svg";
export { ForwardRef as ReactComponent };